import { render, staticRenderFns } from "./DraftPriceCalculatedRoutes.vue?vue&type=template&id=2adf123e&"
import script from "./DraftPriceCalculatedRoutes.vue?vue&type=script&lang=js&"
export * from "./DraftPriceCalculatedRoutes.vue?vue&type=script&lang=js&"
import style0 from "./DraftPriceCalculatedRoutes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports